import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["aria-expanded", "aria-controls", "id"]
const _hoisted_3 = {
  key: 0,
  "aria-hidden": "true",
  class: "header-icon"
}
const _hoisted_4 = { class: "header-title" }
const _hoisted_5 = ["data-testid", "inert", "id", "aria-labelledby"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["accordion", { isExtended: _ctx.isExtended }]),
    role: "presentation",
    "data-testid": _ctx.testId != undefined ? `${_ctx.testId}-accordion` : null,
    style: _normalizeStyle({ height: _ctx.totalHeight })
  }, [
    _createElementVNode("button", {
      class: "header",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      ref: "header",
      "aria-expanded": _ctx.isExtended,
      "aria-controls": 'accordion-section-' + _ctx.accordionId,
      id: 'accordion-header-' + _ctx.accordionId
    }, [
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
        : _createCommentVNode("", true),
      _cache[1] || (_cache[1] = _createElementVNode("span", {
        "aria-hidden": "true",
        class: "header-control"
      }, null, -1)),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1)
    ], 8, _hoisted_2),
    _createElementVNode("section", {
      "data-testid": _ctx.testId != undefined ? _ctx.testId : null,
      class: "content",
      ref: "content",
      inert: !_ctx.isExtended,
      id: 'accordion-section-' + _ctx.accordionId,
      "aria-labelledby": 'accordion-header-' + _ctx.accordionId
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 8, _hoisted_5)
  ], 14, _hoisted_1))
}